export const apiSignature = {
  FETCH_MULTI_STORE_LIST: "multiStore/fetchMultiStoreList",
  ADD_STORE_API: "multiStore/addStoreAPI",
  UPDATE_STORE_API:"multiStore/updateStoreAPI",
  FETCH_BUSSINESS_COUNT_LIST:"multiStore/fetchBussinessCountData",
  ADD_STORE_LOCATION:"multiStore/addStoreLocationAPI",
  UPDATE_STORE_LOCATION:"multiStore/updateStoreLocationAPI"
};
